import React from "react"
import { Select, Divider, Input, Radio, Button, Popover } from "antd"
import questionIcon from "../../images/question.svg"
import lockIcon from "../../images/lock.svg"

const { TextArea } = Input

class EditDivisionForm extends React.Component {
  state = {
    dimension_name: "",
    description: "",
    ponderated: undefined,
  }

  componentDidMount = () => {
    const { title, description, ponderated } = this.props.dimension
    this.setState({
      dimension_name: title,
      description,
      ponderated,
    })
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  hideFooterDrawer = () => {
    const { title, description, ponderated } = this.props.dimension

    return (
      this.state.dimension_name === title &&
      this.state.description === description &&
      this.state.ponderated === ponderated
    )
  }

  render() {
    const contentPonderated = (
      <div style={{ maxWidth: 340, fontSize: 12, color: "#555155" }}>
        El <span style={{ fontWeight: 600 }}>ponderador</span> determina si la
        dimensión tendrá un impacto en el resultado global de clima laboral.
        <ul style={{ paddingLeft: "1rem", marginBottom: 0 }}>
          <li>
            Si el ponderador es <span style={{ fontWeight: 600 }}>1</span>, la
            dimensión <span style={{ fontWeight: 600 }}>sí</span> se tomará en
            cuenta para el cálculo del indicador de clima.
          </li>
          <li>
            Si el ponderador es <span style={{ fontWeight: 600 }}>0</span>,
            aunque la dimensión estará incluida en la encuesta, su resultado{" "}
            <span style={{ fontWeight: 600 }}>no</span> será tomando en
            consideración para el cálculo del clima laboral de la organización.
          </li>
        </ul>
      </div>
    )

    return (
      <div className="question-container">
        <div className="question-container-item">
          <span
            className="question-container-item-title"
            style={{ marginTop: "1rem" }}>
            Nombre de la dimensión
          </span>
          <Input
            style={{ width: "60%" }}
            value={this.state.dimension_name}
            onChange={(e) =>
              this.setStateFrom("dimension_name", e.target.value)
            }
          />
        </div>
        <Divider />
        <div className="question-container-item">
          <img
            src={lockIcon}
            style={{
              position: "absolute",
              right: 32,
            }}
          />
          <span className="question-container-item-title">Dimensión</span>
          <Input
            value={this.props.dimension.name}
            style={{ width: "60%" }}
            disabled
          />
        </div>
        <Divider />
        <div className="question-container-item">
          <span className="question-container-item-title">Descripción</span>
          <TextArea
            rows={4}
            value={this.state.description}
            onChange={(e) => this.setStateFrom("description", e.target.value)}
          />
        </div>
        <Divider />
        <div className="question-container-item">
          <span className="question-container-item-title">
            Ponderador
            <Popover placement="bottom" content={contentPonderated}>
              <img src={questionIcon} style={{ marginLeft: 8 }} />
            </Popover>
          </span>
          <Radio.Group
            value={this.state.ponderated}
            onChange={(e) => this.setStateFrom("ponderated", e.target.value)}>
            <Radio.Button value={0}>0</Radio.Button>
            <Radio.Button value={1}>1</Radio.Button>
          </Radio.Group>
        </div>
        <Divider />
        <div className="question-container-item">
          <span className="question-container-item-title">Traducción</span>
          <Select style={{ width: "60%" }} value="spanish" disabled>
            <Select.Option value="spanish">Español</Select.Option>
          </Select>
        </div>
        {!this.hideFooterDrawer() && (
          <div className="footer-drawer">
            <Button
              style={{ marginRight: 8 }}
              onClick={() => {
                this.props.toggleDrawer("dimensionDrawer", false)
                Intercom('update', { hide_default_launcher: false });
                }}
              >
              Cancelar
            </Button>
            <Button
              // disabled={!this.state.description || !this.state.dimension_name}
              disabled={!this.state.dimension_name}
              type="primary"
              onClick={() => {
                const { dimension } = this.props
                const { dimension_name, description, ponderated } = this.state

                const params = {
                  idDimension: this.props.dimension.id_dimension_has_survey,
                  // params: `?title=${dimension_name}&description=${description}&ponderated=${ponderated}`
                  params: {
                    title: dimension_name,
                    description,
                    ponderated,
                    changePonderated: dimension.ponderated !== ponderated,
                  },
                }

                this.props.updateDimensionWatcher(params)
                this.props.toggleDrawer("dimensionDrawer", false)
                Intercom('update', { hide_default_launcher: false });
              }}>
              Guardar
            </Button>
          </div>
        )}
      </div>
    )
  }
}

export default EditDivisionForm
